var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Access Information"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Access Type"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.data.access_type ? _vm.data.access_type : "N/A")),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Access Number"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(_vm.data.access_number ? _vm.data.access_number : "N/A")
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _vm._m(0),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.special_instructions
                ? _vm.data.special_instructions
                : "N/A"
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex-1 text-16 font-medium minWContent" },
      [
        _vm._v("Special Instructions "),
        _c("br"),
        _c("span", { staticClass: "text-gray-400 font-medium" }, [
          _vm._v("(Parking, Gate Code)"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }